export function createActionCreator(type, payload, accions = {}) {
  if (accions[type]) {
    return accions[type](payload);
  }
  return payload === undefined ? { type } : { type, payload };
}

export default createActionCreator;
